import { Tr as ChakraTableRow, TableRowProps as ChakraTableRowProps } from '@chakra-ui/react';
import React from 'react';

import DisplayNames from './enums';

import { forwardRef } from 'system';

export type TableRowProps = ChakraTableRowProps;

const TableRow = forwardRef(
  (props: TableRowProps, ref): React.ReactElement => {
    return <ChakraTableRow ref={ref} {...props} />;
  }
);

TableRow.displayName = DisplayNames.TableRow;

export default TableRow;
